export default __webpack_public_path__ + "static/media/pumpkinsoup.427350c2.png";